const doc = [({"en":({"js":({"admin":({"plans":({"subscriptions":({"plan_subscriptions":"%{name} - subscriptions"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;